







import { Component, Vue, Prop } from "vue-property-decorator";
import vuepack from '@shield/vuepack'
const { i18n } = vuepack.cache
// import agreementTemplate from "@components/common/agreement/pageTemplate.vue";
import zh from './zh.vue'
import en from './en.vue'
@Component({
  components: {
    // agreementTemplate
  }
})
export default class FRRegister extends Vue {
  // 当前
  private current: any = {}
  // private curAgreement: string = ""
  private get text() {
    return {
      print: this.$t('app.writeDocument'),
      back: this.$t('app.backpp')
    }
  }
  // agreements列表
  private get agreements() {
    return [
      {
        label: '中文',
        value: 'zh',
        title: 'VAT注册资料清单',
        component: zh
      },
      {
        label: 'English',
        value: 'en',
        title: 'VAT Registration List',
        component: en
      }
    ]
  }
  // 条件
  private selectChange(value: any) {
    this.agreements.forEach((data: any) => {
      if (value === data.value) {
        this.current = data
      }
    })
  }
  // 狗子
  private mounted() {
     const lang = (i18n.locale || '').split('-')[0]
      this.selectChange(lang || 'zh')
  }
}
